// Languages of the game app: UI code -> key used in the API data_json / sliders_json
export const GAME_LANG_MAP: Record<string, string> = {
  nl: 'dutch',
  en: 'english',
  es: 'spanish',
  it: 'italian',
  fr: 'french',
  pt: 'portuguese',
  de: 'german',
};

export const GAME_LANG_CODES: string[] = Object.keys(GAME_LANG_MAP);
